<div class="media-image" [class.selected]="isSelected" (click)="toggleSelection()">
  <div class="selection-overlay" *ngIf="isSelected">
    <mat-icon>check_circle</mat-icon>
  </div>
  <div class="public-badge" *ngIf="!image.is_private">
    <mat-icon>public</mat-icon>
    {{ "COMPONENTS.MEDIA_LIBRARY.UPLOAD.VISIBILITY.PUBLIC" | translate }}
  </div>
  <img [src]="image.large_url" alt="" loading="lazy" />
</div>
